import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import PostList from "../components/post-list"
import SEO from "../components/seo"
import Navigation from "../components/navigation"

const IndexPage = ({
  data,
  pageContext: { nextPagePath, previousPagePath },
}) => {
  const {
    allMarkdownRemark: { edges: posts },
  } = data
  // const Posts = edges
  //   .filter((edge) => !!edge.node.frontmatter.date) // You can filter your posts based on some criteria
  //   .map((edge) => <PostLink key={edge.node.id} post={edge.node} />)

  return (
    <>
      <SEO title="홈" lang="kr" description="우리들의 기록" />
      <Layout>
        {previousPagePath}
        <PostList postEdges={posts} />
        <Navigation
          previousPath={previousPagePath}
          previousLabel="Newer posts"
          nextPath={nextPagePath}
          nextLabel="Older posts"
        />
      </Layout>
    </>
  )
}

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.shape({
    nextPagePath: PropTypes.string,
    previousPagePath: PropTypes.string,
  }),
}

export const pageQuery = graphql`
  query($skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      sort: { fields: [fields___date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          excerpt(truncate: true)
          fields {
            slug
            date
          }
          frontmatter {
            author
            title
            tags
            coverImage {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`

export default IndexPage
